import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';
import { TruncateComponent } from '../truncate/truncate.component';

@Component({
  selector: 'rt-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.wrap]': 'wrapText',
    '[class.deletable]': 'deletable',
    '[class.disabled]': 'disabled',
    '[class.has-no-left-margin]': 'hasNoLeftMargin',
    '[class.hoverable]': 'isHoverable',
    '[class.clickable]': 'isClickable',
    '[class.avatar]': 'avatar',
  },
  imports: [NgTemplateOutlet, TruncateComponent, IconComponent],
})
export class TagComponent {
  @Input() public name: string;
  @Input() public deletable?: boolean = false;
  @Input() public counter?: number;
  @Input() public href?: string;
  @Input() public wrapText?: boolean;
  @Input() public symbolTpl?: TemplateRef<any>;
  @Input() public disabled?: boolean;
  @Input() public hasStopPropagation: boolean = false;
  @Input() public hasNoLeftMargin: boolean = false;
  @Input() public isHoverable: boolean = true;
  @Input() public isClickable: boolean = true;
  @Input() public avatar: boolean = false;

  public deleteClick = output<string>();

  public deleteTag(event: MouseEvent, tagName: string): void {
    if (this.hasStopPropagation) {
      event.stopPropagation();
    }
    this.deleteClick.emit(tagName);
  }
}
